module.exports = "<p>\n  static-about works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/src/app/static-about/static-about.component.html
// module id = ../../../../../src/app/static-about/static-about.component.html
// module chunks = 0